if (!customElements.get('spp-cart-featured')) {
  customElements.define(
    'spp-cart-featured',
    class extends HTMLElement {
      constructor() {
        super();

        this.requestId = 0;
        this.updateVisibility = this.updateVisibility.bind(this);
      }

      connectedCallback() {
        if (this.dataset.hideWhenAdded !== 'true') return;

        document.addEventListener(
          'theme:cart:change',
          this.updateVisibility
        );
      }

      disconnectedCallback() {
        this.requestId += 1;

        document.removeEventListener(
          'theme:cart:change',
          this.updateVisibility
        );
      }

      async updateVisibility() {
        const requestId = ++this.requestId;
        const root = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store'
          });

          if (!response.ok) return;

          const cart = await response.json();

          if (!this.isConnected || requestId !== this.requestId) {
            return;
          }

          this.hidden = cart.items.some(
            (item) =>
              String(item.product_id) === this.dataset.productId
          );
        } catch {
          // Keep the current visibility if the request fails.
        }
      }
    }
  );
}